var cov_1np0jprm5 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Td.tsx",
      hash = "cfcac1e0644f383665e35dc751afbb0b1d3a7b13",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Td.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 32
        },
        end: {
          line: 8,
          column: 44
        }
      },
      "1": {
        start: {
          line: 9,
          column: 33
        },
        end: {
          line: 9,
          column: 46
        }
      },
      "2": {
        start: {
          line: 11,
          column: 26
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "3": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 16
        }
      },
      "4": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 62
        }
      },
      "5": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 60
        }
      },
      "6": {
        start: {
          line: 28,
          column: 81
        },
        end: {
          line: 28,
          column: 91
        }
      },
      "7": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 33,
          column: 5
        }
      },
      "8": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 51
        }
      },
      "9": {
        start: {
          line: 30,
          column: 23
        },
        end: {
          line: 30,
          column: 51
        }
      },
      "10": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 78
        }
      },
      "11": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 22
        }
      },
      "12": {
        start: {
          line: 38,
          column: 42
        },
        end: {
          line: 38,
          column: 52
        }
      },
      "13": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 29
        }
      },
      "14": {
        start: {
          line: 43,
          column: 84
        },
        end: {
          line: 43,
          column: 94
        }
      },
      "15": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 52,
          column: 8
        }
      },
      "16": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 56,
          column: 5
        }
      },
      "17": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 55
        }
      },
      "18": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 19
        }
      },
      "19": {
        start: {
          line: 61,
          column: 39
        },
        end: {
          line: 61,
          column: 49
        }
      },
      "20": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 49
        }
      },
      "21": {
        start: {
          line: 62,
          column: 38
        },
        end: {
          line: 62,
          column: 49
        }
      },
      "22": {
        start: {
          line: 64,
          column: 23
        },
        end: {
          line: 64,
          column: 61
        }
      },
      "23": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 34
        }
      },
      "24": {
        start: {
          line: 66,
          column: 23
        },
        end: {
          line: 66,
          column: 34
        }
      },
      "25": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "26": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 52
        }
      },
      "27": {
        start: {
          line: 69,
          column: 27
        },
        end: {
          line: 69,
          column: 52
        }
      },
      "28": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 36
        }
      },
      "29": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 77,
          column: 5
        }
      },
      "30": {
        start: {
          line: 90,
          column: 8
        },
        end: {
          line: 90,
          column: 18
        }
      },
      "31": {
        start: {
          line: 91,
          column: 18
        },
        end: {
          line: 91,
          column: 53
        }
      },
      "32": {
        start: {
          line: 92,
          column: 22
        },
        end: {
          line: 92,
          column: 50
        }
      },
      "33": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 103,
          column: 5
        }
      },
      "34": {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 102,
          column: 7
        }
      },
      "35": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "36": {
        start: {
          line: 117,
          column: 69
        },
        end: {
          line: 117,
          column: 79
        }
      },
      "37": {
        start: {
          line: 119,
          column: 6
        },
        end: {
          line: 121,
          column: 68
        }
      },
      "38": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 59
        }
      },
      "39": {
        start: {
          line: 122,
          column: 45
        },
        end: {
          line: 122,
          column: 59
        }
      },
      "40": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 41
        }
      },
      "41": {
        start: {
          line: 127,
          column: 28
        },
        end: {
          line: 127,
          column: 38
        }
      },
      "42": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 136,
          column: 5
        }
      },
      "43": {
        start: {
          line: 130,
          column: 8
        },
        end: {
          line: 130,
          column: 36
        }
      },
      "44": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 39
        }
      },
      "45": {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 34
        }
      },
      "46": {
        start: {
          line: 152,
          column: 8
        },
        end: {
          line: 152,
          column: 18
        }
      },
      "47": {
        start: {
          line: 154,
          column: 22
        },
        end: {
          line: 165,
          column: 5
        }
      },
      "48": {
        start: {
          line: 167,
          column: 21
        },
        end: {
          line: 167,
          column: 33
        }
      },
      "49": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 170,
          column: 5
        }
      },
      "50": {
        start: {
          line: 169,
          column: 6
        },
        end: {
          line: 169,
          column: 76
        }
      },
      "51": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 173,
          column: 5
        }
      },
      "52": {
        start: {
          line: 172,
          column: 6
        },
        end: {
          line: 172,
          column: 78
        }
      },
      "53": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 179,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        loc: {
          start: {
            line: 21,
            column: 47
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 22
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 27
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 21
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 37
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 30
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 42
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        loc: {
          start: {
            line: 60,
            column: 30
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 60
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 69,
            column: 21
          },
          end: {
            line: 69,
            column: 22
          }
        },
        loc: {
          start: {
            line: 69,
            column: 27
          },
          end: {
            line: 69,
            column: 52
          }
        },
        line: 69
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        },
        loc: {
          start: {
            line: 80,
            column: 39
          },
          end: {
            line: 114,
            column: 3
          }
        },
        line: 80
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 116,
            column: 2
          },
          end: {
            line: 116,
            column: 3
          }
        },
        loc: {
          start: {
            line: 116,
            column: 28
          },
          end: {
            line: 124,
            column: 3
          }
        },
        line: 116
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 126,
            column: 2
          },
          end: {
            line: 126,
            column: 3
          }
        },
        loc: {
          start: {
            line: 126,
            column: 29
          },
          end: {
            line: 137,
            column: 3
          }
        },
        line: 126
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 139,
            column: 3
          }
        },
        loc: {
          start: {
            line: 139,
            column: 11
          },
          end: {
            line: 180,
            column: 3
          }
        },
        line: 139
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }],
        line: 29
      },
      "1": {
        loc: {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 30,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 30,
            column: 51
          }
        }, {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 30,
            column: 51
          }
        }],
        line: 30
      },
      "2": {
        loc: {
          start: {
            line: 32,
            column: 37
          },
          end: {
            line: 32,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 48
          },
          end: {
            line: 32,
            column: 57
          }
        }, {
          start: {
            line: 32,
            column: 60
          },
          end: {
            line: 32,
            column: 77
          }
        }],
        line: 32
      },
      "3": {
        loc: {
          start: {
            line: 51,
            column: 25
          },
          end: {
            line: 51,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 51,
            column: 40
          },
          end: {
            line: 51,
            column: 55
          }
        }, {
          start: {
            line: 51,
            column: 58
          },
          end: {
            line: 51,
            column: 67
          }
        }],
        line: 51
      },
      "4": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        }],
        line: 54
      },
      "5": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 14
          }
        }, {
          start: {
            line: 54,
            column: 18
          },
          end: {
            line: 54,
            column: 46
          }
        }],
        line: 54
      },
      "6": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 49
          }
        }, {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 49
          }
        }],
        line: 62
      },
      "7": {
        loc: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 34
          }
        }, {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 34
          }
        }],
        line: 66
      },
      "8": {
        loc: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }, {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }],
        line: 68
      },
      "9": {
        loc: {
          start: {
            line: 74,
            column: 65
          },
          end: {
            line: 74,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 74,
            column: 76
          },
          end: {
            line: 74,
            column: 81
          }
        }, {
          start: {
            line: 74,
            column: 84
          },
          end: {
            line: 74,
            column: 90
          }
        }],
        line: 74
      },
      "10": {
        loc: {
          start: {
            line: 91,
            column: 18
          },
          end: {
            line: 91,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 18
          },
          end: {
            line: 91,
            column: 48
          }
        }, {
          start: {
            line: 91,
            column: 52
          },
          end: {
            line: 91,
            column: 53
          }
        }],
        line: 91
      },
      "11": {
        loc: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        }],
        line: 93
      },
      "12": {
        loc: {
          start: {
            line: 94,
            column: 6
          },
          end: {
            line: 96,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 94,
            column: 6
          },
          end: {
            line: 94,
            column: 22
          }
        }, {
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 95,
            column: 28
          }
        }, {
          start: {
            line: 96,
            column: 7
          },
          end: {
            line: 96,
            column: 70
          }
        }, {
          start: {
            line: 96,
            column: 74
          },
          end: {
            line: 96,
            column: 90
          }
        }],
        line: 94
      },
      "13": {
        loc: {
          start: {
            line: 99,
            column: 90
          },
          end: {
            line: 99,
            column: 107
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 99,
            column: 101
          },
          end: {
            line: 99,
            column: 102
          }
        }, {
          start: {
            line: 99,
            column: 105
          },
          end: {
            line: 99,
            column: 107
          }
        }],
        line: 99
      },
      "14": {
        loc: {
          start: {
            line: 109,
            column: 65
          },
          end: {
            line: 109,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 109,
            column: 78
          },
          end: {
            line: 109,
            column: 83
          }
        }, {
          start: {
            line: 109,
            column: 86
          },
          end: {
            line: 109,
            column: 92
          }
        }],
        line: 109
      },
      "15": {
        loc: {
          start: {
            line: 119,
            column: 6
          },
          end: {
            line: 121,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 120,
            column: 11
          },
          end: {
            line: 120,
            column: 43
          }
        }, {
          start: {
            line: 121,
            column: 11
          },
          end: {
            line: 121,
            column: 67
          }
        }],
        line: 119
      },
      "16": {
        loc: {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 59
          }
        }, {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 59
          }
        }],
        line: 122
      },
      "17": {
        loc: {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 122,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 122,
            column: 24
          }
        }, {
          start: {
            line: 122,
            column: 28
          },
          end: {
            line: 122,
            column: 43
          }
        }],
        line: 122
      },
      "18": {
        loc: {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 129,
            column: 6
          },
          end: {
            line: 130,
            column: 36
          }
        }, {
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 131,
            column: 20
          }
        }, {
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 133,
            column: 39
          }
        }, {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 135,
            column: 34
          }
        }],
        line: 128
      },
      "19": {
        loc: {
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 144,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 144,
            column: 14
          },
          end: {
            line: 144,
            column: 16
          }
        }],
        line: 144
      },
      "20": {
        loc: {
          start: {
            line: 157,
            column: 8
          },
          end: {
            line: 157,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 8
          },
          end: {
            line: 157,
            column: 24
          }
        }, {
          start: {
            line: 157,
            column: 28
          },
          end: {
            line: 157,
            column: 44
          }
        }],
        line: 157
      },
      "21": {
        loc: {
          start: {
            line: 158,
            column: 8
          },
          end: {
            line: 158,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 8
          },
          end: {
            line: 158,
            column: 25
          }
        }, {
          start: {
            line: 158,
            column: 29
          },
          end: {
            line: 158,
            column: 46
          }
        }],
        line: 158
      },
      "22": {
        loc: {
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 159,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 159,
            column: 18
          }
        }, {
          start: {
            line: 159,
            column: 22
          },
          end: {
            line: 159,
            column: 35
          }
        }],
        line: 159
      },
      "23": {
        loc: {
          start: {
            line: 160,
            column: 8
          },
          end: {
            line: 160,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 160,
            column: 8
          },
          end: {
            line: 160,
            column: 17
          }
        }, {
          start: {
            line: 160,
            column: 21
          },
          end: {
            line: 160,
            column: 33
          }
        }],
        line: 160
      },
      "24": {
        loc: {
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 161,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 161,
            column: 9
          },
          end: {
            line: 161,
            column: 28
          }
        }, {
          start: {
            line: 161,
            column: 32
          },
          end: {
            line: 161,
            column: 49
          }
        }, {
          start: {
            line: 161,
            column: 53
          },
          end: {
            line: 161,
            column: 74
          }
        }, {
          start: {
            line: 161,
            column: 79
          },
          end: {
            line: 161,
            column: 89
          }
        }],
        line: 161
      },
      "25": {
        loc: {
          start: {
            line: 162,
            column: 8
          },
          end: {
            line: 162,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 8
          },
          end: {
            line: 162,
            column: 24
          }
        }, {
          start: {
            line: 162,
            column: 28
          },
          end: {
            line: 162,
            column: 44
          }
        }],
        line: 162
      },
      "26": {
        loc: {
          start: {
            line: 163,
            column: 8
          },
          end: {
            line: 163,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 163,
            column: 8
          },
          end: {
            line: 163,
            column: 25
          }
        }, {
          start: {
            line: 163,
            column: 29
          },
          end: {
            line: 163,
            column: 50
          }
        }],
        line: 163
      },
      "27": {
        loc: {
          start: {
            line: 168,
            column: 4
          },
          end: {
            line: 170,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 168,
            column: 4
          },
          end: {
            line: 170,
            column: 5
          }
        }, {
          start: {
            line: 168,
            column: 4
          },
          end: {
            line: 170,
            column: 5
          }
        }],
        line: 168
      },
      "28": {
        loc: {
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 168,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 168,
            column: 24
          }
        }, {
          start: {
            line: 168,
            column: 28
          },
          end: {
            line: 168,
            column: 38
          }
        }],
        line: 168
      },
      "29": {
        loc: {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        }, {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        }],
        line: 171
      },
      "30": {
        loc: {
          start: {
            line: 171,
            column: 8
          },
          end: {
            line: 171,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 171,
            column: 8
          },
          end: {
            line: 171,
            column: 25
          }
        }, {
          start: {
            line: 171,
            column: 29
          },
          end: {
            line: 171,
            column: 40
          }
        }],
        line: 171
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0, 0, 0],
      "19": [0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0, 0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Td.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { tableClass } from './styles';
import Checkbox from './Checkbox';
import { getDirectionX } from '../utils/dom/translate';
export var CLASS_FIXED_LEFT = (cov_1np0jprm5.s[0]++, 'fixed-left');
export var CLASS_FIXED_RIGHT = (cov_1np0jprm5.s[1]++, 'fixed-right');
var DefaultProps = (cov_1np0jprm5.s[2]++, {
  fixed: '',
  style: {},
  align: 'left'
});

var Td =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Td, _PureComponent);

  var _super = _createSuper2(Td);

  function Td(props) {
    var _this;

    _classCallCheck(this, Td);

    cov_1np0jprm5.f[0]++;
    cov_1np0jprm5.s[3]++;
    _this = _super.call(this, props);
    _this.cachedRender = void 0;
    cov_1np0jprm5.s[4]++;
    _this.handleExpandClick = _this.handleExpandClick.bind(_assertThisInitialized(_this));
    cov_1np0jprm5.s[5]++;
    _this.handleTreeExpand = _this.handleTreeExpand.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Td, [{
    key: "handleExpandClick",
    value: function handleExpandClick() {
      cov_1np0jprm5.f[1]++;

      var _ref = (cov_1np0jprm5.s[6]++, this.props),
          originKey = _ref.originKey,
          expanded = _ref.expanded,
          data = _ref.data,
          expandKeys = _ref.expandKeys,
          expandClick = _ref.expandClick,
          resetFixAuto = _ref.resetFixAuto;

      cov_1np0jprm5.s[7]++;

      if (expandKeys) {
        cov_1np0jprm5.b[0][0]++;
        cov_1np0jprm5.s[8]++;

        if (expandClick) {
          cov_1np0jprm5.b[1][0]++;
          cov_1np0jprm5.s[9]++;
          expandClick(data, !expanded);
        } else {
          cov_1np0jprm5.b[1][1]++;
        }
      } else {
        cov_1np0jprm5.b[0][1]++;
        cov_1np0jprm5.s[10]++;
        this.props.onExpand(originKey, expanded ? (cov_1np0jprm5.b[2][0]++, undefined) : (cov_1np0jprm5.b[2][1]++, this.cachedRender));
      }

      cov_1np0jprm5.s[11]++;
      resetFixAuto(true);
    }
  }, {
    key: "handleTreeExpand",
    value: function handleTreeExpand() {
      cov_1np0jprm5.f[2]++;

      var _ref2 = (cov_1np0jprm5.s[12]++, this.props),
          data = _ref2.data,
          onTreeExpand = _ref2.onTreeExpand,
          index = _ref2.index;

      cov_1np0jprm5.s[13]++;
      onTreeExpand(data, index);
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox() {
      cov_1np0jprm5.f[3]++;

      var _ref3 = (cov_1np0jprm5.s[14]++, this.props),
          index = _ref3.index,
          data = _ref3.data,
          datum = _ref3.datum,
          treeColumnsName = _ref3.treeColumnsName,
          treeCheckAll = _ref3.treeCheckAll,
          disabled = _ref3.disabled,
          render = _ref3.render;

      var checkbox = (cov_1np0jprm5.s[15]++,
      /*#__PURE__*/
      React.createElement(Checkbox, {
        force: datum.check(data),
        data: data,
        index: index,
        datum: datum,
        disabled: disabled,
        treeColumnsName: treeCheckAll ? (cov_1np0jprm5.b[3][0]++, treeColumnsName) : (cov_1np0jprm5.b[3][1]++, undefined),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45,
          columnNumber: 7
        }
      }));
      cov_1np0jprm5.s[16]++;

      if ((cov_1np0jprm5.b[5][0]++, render) && (cov_1np0jprm5.b[5][1]++, typeof render === 'function')) {
        cov_1np0jprm5.b[4][0]++;
        cov_1np0jprm5.s[17]++;
        return render(data, index, checkbox);
      } else {
        cov_1np0jprm5.b[4][1]++;
      }

      cov_1np0jprm5.s[18]++;
      return checkbox;
    }
  }, {
    key: "renderExpand",
    value: function renderExpand(index) {
      cov_1np0jprm5.f[4]++;

      var _ref4 = (cov_1np0jprm5.s[19]++, this.props),
          expanded = _ref4.expanded,
          render = _ref4.render,
          data = _ref4.data;

      cov_1np0jprm5.s[20]++;

      if (typeof render !== 'function') {
        cov_1np0jprm5.b[6][0]++;
        cov_1np0jprm5.s[21]++;
        return null;
      } else {
        cov_1np0jprm5.b[6][1]++;
      }

      var _cachedRender = (cov_1np0jprm5.s[22]++, render(data, index));

      cov_1np0jprm5.s[23]++;

      if (!_cachedRender) {
        cov_1np0jprm5.b[7][0]++;
        cov_1np0jprm5.s[24]++;
        return null;
      } else {
        cov_1np0jprm5.b[7][1]++;
      }

      cov_1np0jprm5.s[25]++;

      if (typeof _cachedRender !== 'function') {
        cov_1np0jprm5.b[8][0]++;
        cov_1np0jprm5.s[26]++;

        _cachedRender = function cachedRender() {
          cov_1np0jprm5.f[5]++;
          cov_1np0jprm5.s[27]++;
          return _cachedRender;
        };
      } else {
        cov_1np0jprm5.b[8][1]++;
      }

      cov_1np0jprm5.s[28]++;
      this.cachedRender = _cachedRender;
      cov_1np0jprm5.s[29]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          className: tableClass('expand-indicator', "icon-expand-".concat(expanded ? (cov_1np0jprm5.b[9][0]++, 'sub') : (cov_1np0jprm5.b[9][1]++, 'plus'))),
          onClick: this.handleExpandClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 73,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "renderTreeExpand",
    value: function renderTreeExpand(content) {
      cov_1np0jprm5.f[6]++;

      var _ref5 = (cov_1np0jprm5.s[30]++, this.props),
          data = _ref5.data,
          treeRoot = _ref5.treeRoot,
          treeColumnsName = _ref5.treeColumnsName,
          treeExpand = _ref5.treeExpand,
          originKey = _ref5.originKey,
          treeExpandLevel = _ref5.treeExpandLevel,
          treeIndent = _ref5.treeIndent,
          treeEmptyExpand = _ref5.treeEmptyExpand;

      var level = (cov_1np0jprm5.s[31]++, (cov_1np0jprm5.b[10][0]++, treeExpandLevel.get(originKey)) || (cov_1np0jprm5.b[10][1]++, 0));
      var className = (cov_1np0jprm5.s[32]++, tableClass('expand-wrapped'));
      cov_1np0jprm5.s[33]++;

      if ((cov_1np0jprm5.b[12][0]++, !treeColumnsName) || (cov_1np0jprm5.b[12][1]++, !data[treeColumnsName]) || (cov_1np0jprm5.b[12][2]++, data[treeColumnsName].length === 0) && (cov_1np0jprm5.b[12][3]++, !treeEmptyExpand)) {
        cov_1np0jprm5.b[11][0]++;
        cov_1np0jprm5.s[34]++;
        return (
          /*#__PURE__*/
          React.createElement("span", {
            className: className,
            style: {
              marginLeft: level * treeIndent,
              paddingLeft: treeRoot ? (cov_1np0jprm5.b[13][0]++, 0) : (cov_1np0jprm5.b[13][1]++, 25)
            },
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 99,
              columnNumber: 9
            }
          }, content)
        );
      } else {
        cov_1np0jprm5.b[11][1]++;
      }

      cov_1np0jprm5.s[35]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          className: className,
          style: {
            marginLeft: level * treeIndent
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 105,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          key: "expand-icon",
          onClick: this.handleTreeExpand,
          className: tableClass('icon-tree-expand', "icon-tree-".concat(treeExpand ? (cov_1np0jprm5.b[14][0]++, 'sub') : (cov_1np0jprm5.b[14][1]++, 'plus'))),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 106,
            columnNumber: 9
          }
        }), content)
      );
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      cov_1np0jprm5.f[7]++;

      var _ref6 = (cov_1np0jprm5.s[36]++, this.props),
          render = _ref6.render,
          data = _ref6.data,
          index = _ref6.index,
          treeColumnsName = _ref6.treeColumnsName,
          treeExpandShow = _ref6.treeExpandShow;

      var content = (cov_1np0jprm5.s[37]++, typeof render === 'function' ? (cov_1np0jprm5.b[15][0]++, render(data, index)) : (cov_1np0jprm5.b[15][1]++, data[render]));
      cov_1np0jprm5.s[38]++;

      if ((cov_1np0jprm5.b[17][0]++, !treeColumnsName) || (cov_1np0jprm5.b[17][1]++, !treeExpandShow)) {
        cov_1np0jprm5.b[16][0]++;
        cov_1np0jprm5.s[39]++;
        return content;
      } else {
        cov_1np0jprm5.b[16][1]++;
      }

      cov_1np0jprm5.s[40]++;
      return this.renderTreeExpand(content);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      cov_1np0jprm5.f[8]++;

      var _ref7 = (cov_1np0jprm5.s[41]++, this.props),
          type = _ref7.type,
          index = _ref7.index;

      cov_1np0jprm5.s[42]++;

      switch (type) {
        case 'checkbox':
          cov_1np0jprm5.b[18][0]++;
          cov_1np0jprm5.s[43]++;
          return this.renderCheckbox();

        case 'expand':
          cov_1np0jprm5.b[18][1]++;

        case 'row-expand':
          cov_1np0jprm5.b[18][2]++;
          cov_1np0jprm5.s[44]++;
          return this.renderExpand(index);

        default:
          cov_1np0jprm5.b[18][3]++;
          cov_1np0jprm5.s[45]++;
          return this.renderResult();
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_1np0jprm5.f[9]++;

      var _ref8 = (cov_1np0jprm5.s[46]++, this.props),
          rowSpan = _ref8.rowSpan,
          colSpan = _ref8.colSpan,
          fixed = _ref8.fixed,
          _ref8$style = _ref8.style,
          style = _ref8$style === void 0 ? (cov_1np0jprm5.b[19][0]++, {}) : _ref8$style,
          firstFixed = _ref8.firstFixed,
          lastFixed = _ref8.lastFixed,
          type = _ref8.type,
          align = _ref8.align,
          ignoreBorderRight = _ref8.ignoreBorderRight,
          offsetLeft = _ref8.offsetLeft,
          offsetRight = _ref8.offsetRight;

      var className = (cov_1np0jprm5.s[47]++, classnames(this.props.className, tableClass((cov_1np0jprm5.b[20][0]++, fixed === 'left') && (cov_1np0jprm5.b[20][1]++, CLASS_FIXED_LEFT), (cov_1np0jprm5.b[21][0]++, fixed === 'right') && (cov_1np0jprm5.b[21][1]++, CLASS_FIXED_RIGHT), (cov_1np0jprm5.b[22][0]++, firstFixed) && (cov_1np0jprm5.b[22][1]++, 'fixed-first'), (cov_1np0jprm5.b[23][0]++, lastFixed) && (cov_1np0jprm5.b[23][1]++, 'fixed-last'), ((cov_1np0jprm5.b[24][0]++, type === 'checkbox') || (cov_1np0jprm5.b[24][1]++, type === 'expand') || (cov_1np0jprm5.b[24][2]++, type === 'row-expand')) && (cov_1np0jprm5.b[24][3]++, 'checkbox'), (cov_1np0jprm5.b[25][0]++, align !== 'left') && (cov_1np0jprm5.b[25][1]++, "align-".concat(align)), (cov_1np0jprm5.b[26][0]++, ignoreBorderRight) && (cov_1np0jprm5.b[26][1]++, 'ignore-right-border'))));
      var newStyle = (cov_1np0jprm5.s[48]++, _objectSpread2({}, style));
      cov_1np0jprm5.s[49]++;

      if ((cov_1np0jprm5.b[28][0]++, fixed === 'left') && (cov_1np0jprm5.b[28][1]++, offsetLeft)) {
        cov_1np0jprm5.b[27][0]++;
        cov_1np0jprm5.s[50]++;
        newStyle.transform = "translateX(".concat(getDirectionX("".concat(offsetLeft, "px")), ")");
      } else {
        cov_1np0jprm5.b[27][1]++;
      }

      cov_1np0jprm5.s[51]++;

      if ((cov_1np0jprm5.b[30][0]++, fixed === 'right') && (cov_1np0jprm5.b[30][1]++, offsetRight)) {
        cov_1np0jprm5.b[29][0]++;
        cov_1np0jprm5.s[52]++;
        newStyle.transform = "translateX(".concat(getDirectionX("-".concat(offsetRight, "px")), ")");
      } else {
        cov_1np0jprm5.b[29][1]++;
      }

      cov_1np0jprm5.s[53]++;
      return (
        /*#__PURE__*/
        React.createElement("td", {
          style: newStyle,
          className: className,
          rowSpan: rowSpan,
          colSpan: colSpan,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 176,
            columnNumber: 7
          }
        }, this.renderContent())
      );
    }
  }]);

  return Td;
}(PureComponent);

Td.defaultProps = DefaultProps;
export default Td;